import {
  reverseObject,
  getNormalizedUrl,
  getMinutes,
  getTimeDetailes,
  convertMinutesToTimeString,
} from 'utils';

const getDataObjectSeparatedByLocale = (data = [], key) => {
  const obj = {};

  data.forEach((item) => {
    obj[item.lang] = item[key] === undefined ? '' : item[key];
  });

  return obj;
};

function nullChecker(value, defaultValue = '') {
  if (!value || value === 'null') return defaultValue;
  return value;
}

function getSplittedPositionArray(position = 'bottom-right') {
  const separatedByDash = position.split('-');
  const separatedBySpace = position.split(' ');

  if (separatedByDash.length === 2) return separatedByDash;
  if (separatedBySpace.length === 2) return separatedBySpace;
  return ['bottom', 'right'];
}

// function isPositionCorrupted(position = '') {
//   const separatedByDash = position.split('-');
//   const separatedBySpace = position.split(' ');

//   return separatedByDash.length !== 2 && separatedBySpace.length !== 2;
// }

function getOffsetNumber(offset = '') {
  if (!offset) return '0';
  const value = offset.trim();
  if (value.slice(-2) === 'px') return value.slice(0, value.length - 2);
  return value;
}

export const createStorableState = (data, settings) => {
  let storingLanding = {
    lang: 'fa',
    welcomeText: '',
    intro: '',
    startMessangingTitle: '',
    startMessangingDescription: '',
    hasError: false,
  };

  if (data.landing) {
    storingLanding = {
      lang: data.landing.widgetLang || 'fa',
      welcomeText: {
        ...settings.landing.welcomeText,
        ...getDataObjectSeparatedByLocale(data.landing.langs, 'title'),
      },
      intro: {
        ...settings.landing.intro,
        ...getDataObjectSeparatedByLocale(data.landing.langs, 'desc'),
      },
      startMessangingTitle: {
        ...settings.landing.startMessangingTitle,
        ...getDataObjectSeparatedByLocale(data.landing.langs, 'sendForMe'),
      },
      startMessangingDescription: {
        ...settings.landing.startMessangingDescription,
        ...getDataObjectSeparatedByLocale(data.landing.langs, 'backMessage'),
      },
    };
  }

  const storingCustomizations = {
    logo: data.personalize.isCustomLogo, // uploading logos
    customLogo: data.personalize.logo, // default logos
    primaryColor: nullChecker(data.personalize.bgColor, '#841474'),
    secondaryColor: nullChecker(data.personalize.seColor, '#841474'),
    headerTitleColor: nullChecker(data.personalize.headerTitleColor, '#FFF'),
    logoBgColor: data.personalize.backgroundLogo,
    wallpaper: +nullChecker(data.personalize.wallpaper, 1) - 1,
    hasError: false,
  };

  const storingDisplay = {
    vacation: !!data.displaySetting?.hollyday,
    allowedAddresses: data.displaySetting.showPages.map((p) => {
      return { address: p, id: `${(Math.random() * 10).toFixed(3)}` };
    }),
    allowedAddressesEnable: data.displaySetting.isShowEnable,
    notAllowedAddresses: data.displaySetting.hiddenPages.map((p) => {
      return { address: p, id: `${(Math.random() * 10).toFixed(3)}` };
    }),
    notAllowedAddressesEnable: data.displaySetting.isHideEnable,
    hasError: false,
  };

  const storingPositions = {
    position: {
      rtl: getSplittedPositionArray(data.position.rtl.position).join('-'),
      ltr: getSplittedPositionArray(data.position.ltr.position).join('-'),
    },
    offset1: {
      rtl: getOffsetNumber(
        data.position.rtl[
          getSplittedPositionArray(data.position.rtl.position)[0]
        ]
      ),
      ltr: getOffsetNumber(
        data.position.ltr[
          getSplittedPositionArray(data.position.ltr.position)[0]
        ]
      ),
    },
    offset2: {
      rtl: getOffsetNumber(
        data.position.rtl[
          getSplittedPositionArray(data.position.rtl.position)[1]
        ]
      ),
      ltr: getOffsetNumber(
        data.position.ltr[
          getSplittedPositionArray(data.position.ltr.position)[1]
        ]
      ),
    },
    showWidgetInMobile: {
      rtl: data.position.rtl.loadInPhone,
      ltr:
        data.position.ltr.loadInPhone === null
          ? true
          : data.position.ltr.loadInPhone,
    },
    hasError: false,
  };

  return {
    landing: storingLanding,
    customizations: storingCustomizations,
    view: storingDisplay,
    positions: storingPositions,
  };
};
const conditionTypeToApiVersionObj = {
  time: '1',
  address: '2',
  title: '3',
};

const widgetActionToApiVersion = {
  widgetSpin: 'raychat_btn_shake',
  widgetOpen: 'raychat_open_container',
  widgetClose: 'raychat_close_container',
  shortMessage: 'raychat_send_message',
  widgetOpensMessageSent: 'raychat_send_message_open',
};

const equalityTypeToApiVersionObj = {
  equal: '==',
  notEqual: '=!',
  startWith: 'starts',
  endWith: 'end',
  notInclude: 'ncontains',
  include: 'contains',
  lessAndEqual: '=>',
  less: '>',
  bigger: '<',
  biggerAndEqual: '=<',
};

const getApiConditions = (conditions) => {
  return conditions.map((item) => ({
    cond: conditionTypeToApiVersionObj[item.type],
    eq: equalityTypeToApiVersionObj[item.eq],
    value: item.value,
  }));
};

const getConvertedConditions = (conditions) => {
  const condTypeConvertObj = reverseObject(conditionTypeToApiVersionObj);
  const equalityConvertObj = reverseObject(equalityTypeToApiVersionObj);

  return conditions.map((item) => ({
    id: Math.floor(Math.random() * 100000000),
    type: condTypeConvertObj[item.cond],
    eq: equalityConvertObj[item.eq],
    value: item.value,
  }));
};

export const createAutoMessageObject = (apiObject) => ({
  id: apiObject._id,
  title: apiObject.name,
  status: apiObject.enabled ? 'active' : 'inActive',
  sender: apiObject.sender
    ? { type: apiObject.sender.type, id: apiObject.sender.id }
    : '',
  lastUpdate: apiObject.createdAt
    ? new Date(apiObject.createdAt).toLocaleDateString('fa-IR')
    : '',
  updatedBy: apiObject.creator,
  messageText: apiObject.message,
  showType: apiObject.displayMode,
  numberOfConditions: apiObject.numberOfConditions,
  withVoice: !apiObject.mute,
  sendMsgInMobile: apiObject.mobile,
  showJustOnce: apiObject.justOnce,
  conditions: getConvertedConditions(apiObject.conditions),
  triggerAction: reverseObject(widgetActionToApiVersion)[apiObject.commands],
  publishTime: {
    startPublishTime: apiObject.publish.starter,
    endPublishTime: apiObject.publish.end,
    allowedPublishTime: apiObject.publish.when,
  },
});

export const createApiAutoMessageObject = (message) => ({
  triggerId: message.id,
  name: message.title,
  enabled: message.status === 'active',
  mobile: message.sendMsgInMobile,
  mute: !message.withVoice,
  displayMode: message.showType,
  numberOfConditions: message.numberOfConditions,
  justOnce: message.showJustOnce,
  commands: widgetActionToApiVersion[message.triggerAction],
  message: message.messageText,
  conditions: getApiConditions(message.conditions),
  sender: message.sender
    ? { type: message.sender.type, id: message.sender.id }
    : '',
  publish: {
    starter: message.publishTime.startPublishTime,
    end: message.publishTime.endPublishTime,
    when: message.publishTime.allowedPublishTime,
  },
});

export const createAutoMessagesObjects = (apiObject) => {
  return apiObject.map((item) => createAutoMessageObject(item)).reverse();
};

// office hours
export const createOfficeHoursSettingsObject = (
  officeApiObj,
  nonOfficeApiObj
) => ({
  officeHours: officeApiObj.map((item) => ({
    id: item.key,
    active: item.active,
    from: getMinutes(getTimeDetailes(item.from)),
    to: getMinutes(getTimeDetailes(item.to)),
    key: item.key,
  })),

  onlineMode: nonOfficeApiObj.changeToOnlineMode === 'true',
  offlineMsg: nonOfficeApiObj.offlineMessage.active === 'true',
  deactiveMode: nonOfficeApiObj.disableTriggers === 'true',
  telegramMsg: nonOfficeApiObj.sendMessageToTelegram === 'true',
  widgetSleepMode: nonOfficeApiObj.sleepLogo === 'true',
  hideWidget: nonOfficeApiObj.hideWidget === 'true',
  disableChat: nonOfficeApiObj.disableChat ?? false,

  formSettings: {
    formFields: nonOfficeApiObj.offlineMessage.form.fieldName,
    forceGetUserDetails:
      nonOfficeApiObj.offlineMessage.form.forceGetUserDetails === 'true',
    beforeSendingMessage:
      nonOfficeApiObj.offlineMessage.form.beforeSendingMessage === 'true',
    formMessageEnabled:
      nonOfficeApiObj.offlineMessage.offlineMessage.active === 'true',
    formMessage: nonOfficeApiObj.offlineMessage.offlineMessage.message,
  },
});

export const getApiReadyOfficeHoursSettings = (settings, channelId) => ({
  channelId,
  action: 'officeHours',
  officeHours: settings.officeHours
    .filter((item) => item.key)
    .map((item) => ({
      from: convertMinutesToTimeString(item.from),
      to: convertMinutesToTimeString(item.to),
      key: item.key,
      active: 'true',
    })),
  notOfficeHours: {
    hideWidget: settings.hideWidget ? 'true' : 'false',
    sendMessageToTelegram: settings.telegramMsg ? 'true' : 'false',
    sleepLogo: settings.widgetSleepMode ? 'true' : 'false',
    disableTriggers: settings.deactiveMode ? 'true' : 'false',
    changeToOnlineMode: settings.onlineMode ? 'true' : 'false',
    disableChat: settings.disableChat,
    offlineMessage: {
      active: settings.offlineMsg ? 'true' : 'false',
      form: {
        forceGetUserDetails: settings.formSettings.forceGetUserDetails
          ? 'true'
          : 'false',
        beforeSendingMessage: settings.formSettings.beforeSendingMessage
          ? 'true'
          : 'false',
        fieldName: settings.formSettings.formFields,
      },
      offlineMessage: {
        active: settings.formSettings.formMessageEnabled ? 'true' : 'false',
        message: settings.formSettings.formMessage,
      },
    },
  },
});

export const createEmailSettingsObject = (settings) => ({
  sendMail: settings.sendMail === 'true',
  emailSubject: settings.emailSubject,
  emailContent: settings.emailContent,
});

export const getEmailSettingsApiPayload = (settings) => ({
  emailSettingObj: {
    sendMail: settings.sendMail ? 'true' : 'false',
    emailSubject: settings.emailSubject,
    emailContent: settings.emailContent,
  },
  channelId: settings.channelId,
});

// In fact the default text should be set from back-end side. but it is not always set so for that case we set this fallback text
const getDefaultOfflineMsg = (locale) => {
  if (locale === 'en') {
    return 'To continue the conversation please enter your information';
  }

  return 'برای ادامه مکالمه، لطفا اطلاعات خود را وارد کنید.';
};

export const createGeneralSettingsObject = (settings, locale) => ({
  logo: { url: getNormalizedUrl(settings.photo), file: null },
  typingWordsDisplay: settings.SeeTypedSentences,
  lastSavedLogo: settings.photo,
  logoFile: null,
  sendVoiceFromWidget: settings.sendVoiceWidget,
  sendFileWidget: settings.sendFileWidget ?? true,
  hideRaychatLogo: settings.hideRaychatLogo,
  infoForm: settings.sendForm?.active === 'true',

  formSettings: {
    formFields: settings.sendForm?.form.fieldName || 'email',
    forceGetUserDetails: settings.sendForm?.form.forceGetUserDetails === 'true',
    beforeSendingMessage:
      settings.sendForm?.form.beforeSendingMessage === 'true',
    formMessageEnabled: settings.sendForm?.offlineMessage.active === 'true',
    formMessage:
      settings.sendForm?.offlineMessage.message || getDefaultOfflineMsg(locale),
  },
});

export const getApiReadyGeneralSettings = (settings) => ({
  key: 'channelSetting',
  channelId: settings.channelId,
  newPhoto: settings.logo,
  meta: {
    lang: 'fa',
    sendVoiceWidget: settings.sendVoiceFromWidget ? '1' : '0',
    SeeTypedSentences: settings.typingWordsDisplay ? '1' : '0',
    hideRaychatLogo: settings.hideRaychatLogo ? '1' : '0',
    sendFileWidget: settings.sendFileWidget,
  },
  sendForm: {
    active: settings.infoForm ? 'true' : 'false',
    form: {
      forceGetUserDetails: settings.formSettings.forceGetUserDetails
        ? 'true'
        : 'false',
      beforeSendingMessage: settings.formSettings.beforeSendingMessage
        ? 'true'
        : 'false',
      fieldName: settings.formSettings.formFields || 'email',
    },
    offlineMessage: {
      active: settings.formSettings.formMessageEnabled ? 'true' : 'false',
      message: settings.formSettings.formMessage,
    },
  },
});

export const getToggleStatusNotif = (statusText, locale) => {
  if (locale === 'fa') return `پیام ${statusText} شد`;

  return `message ${statusText}`;
};
